<script>
import {formatDate} from "@/lib";

export default {
  name: "EventLocationAndTime",
  methods: {formatDate},
  props: ["event"],
  computed: {
    parsedDate() {
      return new Date(this.event.SortKey);
    },
    dow() {
      return this.parsedDate.toLocaleDateString("de-DE", { weekday: "long"});
    },
    timespan() {
      const start = this.event.Termin.Start.slice(0, 5);
      const end = this.event.Termin.Ende.slice(0, 5);

      return `${start} - ${end} Uhr`;
    },
    address() {
      return this.event.Adresse;
    }
  }
}
</script>

<template>
<v-row class="location-time-row px-5 py-3" no-gutters>
  <v-col cols="12" sm="6" v-if="event.SortKey">
    <span class="font-weight-bold">Termin</span>
    <p v-if="!event.Termin.Freitext">
      {{ dow }}, {{ formatDate(parsedDate)}} <br>
      {{ timespan }}
    </p>
    <p v-else style="white-space: pre-line;">
      {{ event.Termin.Freitext }}
    </p>
  </v-col>
  <v-col cols="12" sm="6">
    <span class="font-weight-bold">Ort</span>
    <p v-if="address.Ort !== 'Online'">
      {{ address.Bezeichnung }}<br>
      {{ address.Strasse }} {{ address.Hausnummer}} <br>
      {{ address.PLZ }} {{ address.Ort}}
    </p>
    <p v-else>
      {{ address.Ort }}
    </p>
  </v-col>
</v-row>
</template>

<style scoped>
.location-time-row {
  background: rgb(232,212,223);
}
</style>